import { render, staticRenderFns } from "./customers_requests.vue?vue&type=template&id=6166c5c1&"
import script from "./customers_requests.vue?vue&type=script&lang=js&"
export * from "./customers_requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports